<div class="l_flex l_flex-justify m-l_flexbar-col guts-p-b-2">
  <ul class="l_flexbar par par--small m-guts-m-b-1">
    <li
      class="ib guts-m-r-2 guts-p-v-half"
      *ngIf="isEditing || target.primaryContact"
    >
      <span class="font-semibold">{{ i18n.FlexCtrl_PrimaryContact }}: </span>
      <span *ngIf="target.primaryContact">
        <a
          class="link color-ebony"
          [href]="'/profile/' + target.primaryContact.vanityUrl"
          data-dgat="flex-meta-data-f67"
        >
          {{ target.primaryContact.name }}</a
        >
      </span>
      <button
        *ngIf="isEditing"
        df-button
        df-button-square
        dfButtonType="clear"
        [ngbTooltip]="i18n.FlexCtrl_EditPrimaryContact"
        (click)="editPrimaryContact()"
        class="guts-m-l-quart"
        data-dgat="flex-meta-data-9f7"
      >
        <df-icon class="color-ebony-a61" icon="pencil"></df-icon>
      </button>
    </li>
    <li class="ib guts-m-r-2 guts-p-v-half">
      <span class="font-semibold">{{ i18n.Core_LastUpdated }}: </span>
      <span>{{ target.dateModified | date: 'shortDate' }}</span>
    </li>
    <li *ngIf="!hideCollaborators" class="l_flexbar guts-m-r-2 guts-p-v-half">
      <span class="font-semibold">{{ i18n.Core_Collaborators }}: </span>
      <dgx-users-pictures
        class="guts-m-l-half"
        [isEditing]="isEditing"
        [users]="target.authors"
        (onEdit)="onEditCollaborators()"
      >
      </dgx-users-pictures>
    </li>
    <li>
      <span>{{ privacyLevel }}</span>
    </li>
  </ul>
  <div class="l_flex-shrink" *ngIf="isEditing">
    <button
      df-button
      dfButtonType="passive"
      class="bg-color-white"
      (click)="modifyMetadata()"
      data-dgat="flexFramework-index-7d6"
    >
      <df-icon icon="pencil" class="guts-m-r-half"></df-icon>
      {{
        metaIsEmpty ? i18n.FlexCtrl_AddProperties : i18n.FlexCtrl_EditProperties
      }}
    </button>
  </div>
</div>

<div class="l_flex l_flex-justify m-l_flexbar-col">
  <ul class="par par--small m-guts-m-b-1">
    <li
      class="ib guts-m-r-2 guts-p-v-half"
      *ngFor="let data of target.metadata"
      data-dgat="flexCtrl-Index-68d"
    >
      <span class="font-semibold">{{ data.property }}: </span>
      <span>{{ data.value }}</span>
    </li>
  </ul>
</div>
